import { render, staticRenderFns } from "./AS_Award.vue?vue&type=template&id=0739827b&scoped=true&"
import script from "./AS_Award.vue?vue&type=script&lang=js&"
export * from "./AS_Award.vue?vue&type=script&lang=js&"
import style0 from "./AS_Award.vue?vue&type=style&index=0&id=0739827b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0739827b",
  null
  
)

export default component.exports